import toast from 'react-hot-toast';
import { io } from 'socket.io-client';
import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import api from '../services/api';
import ProfileEditModal from './ProfileEditModal';
import ZoikLogo from './ZoikLogo';

const MENU = [
  { path: '/dashboard', label: 'Dashboard', roles: ['ADMIN', 'CUENTAS', 'CONTENIDO', 'DISENO', 'ESTRATEGIA', 'CLIENTE'] },
  { path: '/chat', label: 'Chat', roles: ['ADMIN', 'CUENTAS', 'CONTENIDO', 'DISENO', 'ESTRATEGIA', 'CLIENTE'] },
  { path: '/calendar', label: 'Calendario', roles: ['ADMIN', 'CUENTAS', 'CONTENIDO', 'DISENO', 'ESTRATEGIA', 'CLIENTE'] },
  { path: '/drive', label: 'Drive', roles: ['ADMIN', 'CUENTAS', 'CONTENIDO', 'DISENO', 'ESTRATEGIA', 'CLIENTE'] },
  { path: '/brands', label: 'Marcas', roles: ['ADMIN', 'CUENTAS', 'CONTENIDO', 'DISENO', 'ESTRATEGIA', 'CLIENTE'] },
  { path: '/content', label: 'Contenido', roles: ['ADMIN', 'CUENTAS', 'CONTENIDO', 'DISENO', 'ESTRATEGIA', 'CLIENTE'] },
  { path: '/production', label: 'Producción', roles: ['ADMIN'] },
  { path: '/processes', label: 'Procesos', roles: ['ADMIN', 'CUENTAS', 'CONTENIDO', 'DISENO', 'ESTRATEGIA', 'CLIENTE'] },
  { path: '/team', label: 'Workspace', roles: ['ADMIN', 'CUENTAS', 'CONTENIDO', 'DISENO', 'ESTRATEGIA', 'CLIENTE'] },
  { path: '/permissions', label: 'Permisos y Horas Extra', roles: ['ADMIN', 'CUENTAS', 'CONTENIDO', 'DISENO', 'ESTRATEGIA', 'CLIENTE'] },
  { path: '/linkedin', label: 'CHARGE Ops', roles: ['ADMIN', 'CUENTAS', 'CONTENIDO', 'DISENO', 'ESTRATEGIA', 'CLIENTE'] },
];

const ICON_SVGS: Record<string, React.ReactNode> = {
  '/linkedin': (
    <svg className="icon-anim-charge" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path className="charge-lightning" d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" stroke="#fbbf24" fill="#fbbf24" fillOpacity="0.2"/>
    </svg>
  ),

  '/dashboard': (
    <svg className="icon-anim-dashboard" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect className="dash-cube cube-tl" x="3" y="3" width="7" height="7" rx="1.5" />
      <rect className="dash-cube cube-tr" x="14" y="3" width="7" height="7" rx="1.5" />
      <rect className="dash-cube cube-br" x="14" y="14" width="7" height="7" rx="1.5" />
      <rect className="dash-cube cube-bl" x="3" y="14" width="7" height="7" rx="1.5" />
    </svg>
  ),
  '/chat': (
    <svg className="icon-anim-chat" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
    </svg>
  ),
  '/calendar': (
    <svg className="icon-anim-calendar" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
      <line x1="16" y1="2" x2="16" y2="6" />
      <line x1="8" y1="2" x2="8" y2="6" />
      <line x1="3" y1="10" x2="21" y2="10" />
      <g className="cal-sheet-flipper" style={{ transformOrigin: 'center 10px' }}>
        <line x1="7" y1="14" x2="17" y2="14" strokeWidth="1.6" strokeDasharray="2.5 2.5" />
        <line x1="7" y1="18" x2="13" y2="18" strokeWidth="1.6" strokeDasharray="2.5 2.5" />
      </g>
    </svg>
  ),
  '/drive': (
    <svg className="icon-anim-drive" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path className="drive-back" d="M4 19V5a2 2 0 0 1 2-2h5l2 3h7a2 2 0 0 1 2 2v2" />
      <path className="drive-front" d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v10z" style={{ transformOrigin: 'center bottom' }} />
    </svg>
  ),
  '/brands': (
    <svg className="icon-anim-brands" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z" />
      <line x1="7" y1="7" x2="7.01" y2="7" />
    </svg>
  ),
  '/content': (
    <svg className="icon-anim-content" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="3" width="18" height="18" rx="2" />
      <line className="content-line-h" x1="3" y1="9" x2="21" y2="9" />
      <line className="content-line-v" x1="9" y1="21" x2="9" y2="9" />
    </svg>
  ),
  '/production': (
    <svg className="icon-anim-production" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      {/* Engranaje Principal (Gira en sentido horario) */}
      <g className="gear-main" style={{ transformOrigin: '8.5px 8.5px' }}>
        <circle cx="8.5" cy="8.5" r="2.5" />
        <path d="M8.5 2v2M8.5 13v2M2 8.5h2M13 8.5h2M3.9 3.9l1.4 1.4M11.7 11.7l1.4 1.4M3.9 13.1l1.4-1.4M11.7 5.3l1.4-1.4" />
      </g>
      {/* Engranaje Secundario (Gira en sentido antihorario) */}
      <g className="gear-sub" style={{ transformOrigin: '16.5px 16.5px' }}>
        <circle cx="16.5" cy="16.5" r="2" />
        <path d="M16.5 12v1.5M16.5 19.5v1.5M12 16.5h1.5M19.5 16.5h1.5M13.3 13.3l1.1 1.1M18.6 18.6l1.1 1.1M13.3 19.7l1.1-1.1M18.6 14.4l1.1-1.1" />
      </g>
    </svg>
  ),
  '/processes': (
    <svg className="icon-anim-processes" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="23 4 23 10 17 10" />
      <polyline points="1 20 1 14 7 14" />
      <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15" />
    </svg>
  ),
  '/permissions': (
    <svg className="icon-anim-calendar" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
      <line x1="16" y1="2" x2="16" y2="6" />
      <line x1="8" y1="2" x2="8" y2="6" />
      <line x1="3" y1="10" x2="21" y2="10" />
      <path d="M9 16l2 2 4-4" stroke="#0070f3" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  '/team': (
    <svg className="icon-anim-team" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <g className="team-p-left">
        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
        <circle cx="9" cy="7" r="4" />
      </g>
      <g className="team-p-right">
        <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
        <path d="M16 3.13a4 4 0 0 1 0 7.75" />
      </g>
    </svg>
  ),
};

const ROLE_LABELS: Record<string, string> = {
  ADMIN: 'Admin',
  CUENTAS: 'Cuentas',
  CONTENIDO: 'Contenido',
  DISENO: 'Diseño',
  ESTRATEGIA: 'Estrategia',
  CLIENTE: 'Cliente'
};

const NOTIF_ICONS: Record<string, string> = {
  SUBIDA: '↑',
  APROBADO: '✓',
  CAMBIOS: '↻',
  COMENTARIO: '◎'
};

const timeAgo = (date: string) => {
  const diff = Date.now() - new Date(date).getTime();
  const m = Math.floor(diff / 60000);
  if (m < 1) return 'Ahora';
  if (m < 60) return `Hace ${m}m`;
  const h = Math.floor(m / 60);
  if (h < 24) return `Hace ${h}h`;
  return `Hace ${Math.floor(h / 24)}d`;
};

const MOBILE_STATUS_CONFIG: Record<string, { label: string; emoji: string; color: string }> = {
  ONLINE: { label: 'Online', emoji: '🟢', color: '#10b981' },
  BUSY: { label: 'Ocupado', emoji: '🔴', color: '#ef4444' },
  OFFLINE: { label: 'Ausente', emoji: '🟡', color: '#f59e0b' }
};

export const Sidebar: React.FC = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const [mobilePresence, setMobilePresence] = useState<'ONLINE' | 'BUSY' | 'OFFLINE'>('ONLINE');

  // Hovered Tooltip State
  const [hoveredItem, setHoveredItem] = useState<string | null>(null);

  // Avisos Generales (Mail)
  const [showAnnouncements, setShowAnnouncements] = useState(false);
  const announcementsRef = useRef<HTMLDivElement>(null);

  // Notificaciones
  const [notifications, setNotifications] = useState<any[]>([]);
  const [showNotif, setShowNotif] = useState(false);
  const notifRef = useRef<HTMLDivElement>(null);
  const prevUnreadRef = useRef<number>((() => { try { return parseInt(sessionStorage.getItem('notifUnreadCount') || '0', 10); } catch { return 0; } })());

  // Chat Notifications
  const [chatToast, setChatToast] = useState<any>(null);

  const [chatUnreadCount, setChatUnreadCount] = useState<number>(0);

  const loadChatUnread = async () => {
    try {
      const res = await api.get('/chat/unread-count');
      setChatUnreadCount(res.data?.unread || 0);
    } catch {}
  };

  const chatToastTimer = useRef<any>(null);
  const prevChatUnread = useRef<{ [key: string]: number }>((() => {
    try { return JSON.parse(sessionStorage.getItem('chatUnreadMap') || '{}'); } catch { return {}; }
  })());

  const playChatSound = () => {
    try {
      const ctx = new (window.AudioContext || (window as any).webkitAudioContext)();
      [0, 0.1, 0.2].forEach((t, i) => {
        const o = ctx.createOscillator(); const g = ctx.createGain();
        o.connect(g); g.connect(ctx.destination);
        o.frequency.value = [1200, 1000, 1400][i];
        g.gain.setValueAtTime(0.2, ctx.currentTime + t);
        g.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + t + 0.12);
        o.start(ctx.currentTime + t); o.stop(ctx.currentTime + t + 0.12);
      });
    } catch {}
  };

  const loadChatNotifications = async () => {
    try {
      const r = await api.get('/chat/conversations');
      const convs = Array.isArray(r.data) ? r.data : [];
      convs.forEach((c: any) => {
        const prev = prevChatUnread.current[c.id] || 0;
        if (c.unread > prev && c.lastMessage) {
          const isFocusEnabled = localStorage.getItem('zoik_focus_mode_enabled') === 'true';
          if (isFocusEnabled && c.type !== 'GROUP') {
            try {
              const focusAllowed = JSON.parse(localStorage.getItem('zoik_focus_allowed_users') || '[]');
              const senderId = c.lastMessage?.senderId || c.lastMessage?.sender?.id;
              if (!senderId || !focusAllowed.includes(senderId)) {
                return;
              }
            } catch (e) {}
          }
          const msg = c.lastMessage;
          const senderName = `${msg.sender?.firstName || ''} ${msg.sender?.lastName || ''}`.trim();
          const preview = msg.fileType === 'audio' ? '🎤 Nota de voz' : msg.fileType === 'image' ? '📷 Imagen' : msg.fileType === 'document' ? `📎 ${msg.fileName || 'Archivo'}` : msg.content?.slice(0, 80) || '';
          setChatToast({ convId: c.id, convName: c.displayName, senderName, preview, avatar: msg.sender?.avatar, isGroup: c.type === 'GROUP' });
          if (!window.location.pathname.includes('/chat')) playChatSound();
          if (chatToastTimer.current) clearTimeout(chatToastTimer.current);
          chatToastTimer.current = setTimeout(() => setChatToast(null), 10000);
        }
      });
      const newMap: { [key: string]: number } = {};
      convs.forEach((c: any) => { newMap[c.id] = c.unread; });
      prevChatUnread.current = newMap;
      try { sessionStorage.setItem('chatUnreadMap', JSON.stringify(newMap)); } catch {}
    } catch {}
  };

  // ESTILO DE ANIMACIÓN DE PULSO Y BRILLO PARA LA CAMPANA
if (typeof document !== 'undefined' && !document.getElementById('notif-pulse-css')) {
  const style = document.createElement('style');
  style.id = 'notif-pulse-css';
  style.innerHTML = `
    @keyframes bellGlowPulse {
      0% {
        box-shadow: 0 0 0 0 rgba(0, 112, 243, 0.9), 0 0 16px #0070f3;
        transform: scale(1);
      }
      50% {
        box-shadow: 0 0 0 10px rgba(0, 112, 243, 0), 0 0 26px #0070f3;
        transform: scale(1.06);
      }
      100% {
        box-shadow: 0 0 0 0 rgba(0, 112, 243, 0), 0 0 16px #0070f3;
        transform: scale(1);
      }
    }
    @keyframes bellShake {
      0%, 100% { transform: rotate(0deg); }
      20%, 60% { transform: rotate(12deg); }
      40%, 80% { transform: rotate(-12deg); }
    }

    /* ========================================================================== */
    /* ANIMACIONES EXCLUSIVAS DE LOS ICONOS DEL SIDEBAR                           */
    /* ========================================================================== */

    /* 1. DASHBOARD: Se arman los cubitos */
    @keyframes cubeAssembleTL {
      0% { transform: translate(0, 0) scale(1); }
      30% { transform: translate(-4px, -4px) scale(0.5); opacity: 0.3; }
      70% { transform: translate(1px, 1px) scale(1.1); opacity: 1; }
      100% { transform: translate(0, 0) scale(1); opacity: 1; }
    }
    @keyframes cubeAssembleTR {
      0% { transform: translate(0, 0) scale(1); }
      30% { transform: translate(4px, -4px) scale(0.5); opacity: 0.3; }
      70% { transform: translate(-1px, 1px) scale(1.1); opacity: 1; }
      100% { transform: translate(0, 0) scale(1); opacity: 1; }
    }
    @keyframes cubeAssembleBR {
      0% { transform: translate(0, 0) scale(1); }
      30% { transform: translate(4px, 4px) scale(0.5); opacity: 0.3; }
      70% { transform: translate(-1px, -1px) scale(1.1); opacity: 1; }
      100% { transform: translate(0, 0) scale(1); opacity: 1; }
    }
    @keyframes cubeAssembleBL {
      0% { transform: translate(0, 0) scale(1); }
      30% { transform: translate(-4px, 4px) scale(0.5); opacity: 0.3; }
      70% { transform: translate(1px, -1px) scale(1.1); opacity: 1; }
      100% { transform: translate(0, 0) scale(1); opacity: 1; }
    }
    .sidebar-menu-btn:hover .cube-tl, .sidebar-menu-btn.is-active .cube-tl {
      animation: cubeAssembleTL 0.65s cubic-bezier(0.34, 1.56, 0.64, 1);
    }
    .sidebar-menu-btn:hover .cube-tr, .sidebar-menu-btn.is-active .cube-tr {
      animation: cubeAssembleTR 0.65s cubic-bezier(0.34, 1.56, 0.64, 1) 0.06s;
    }
    .sidebar-menu-btn:hover .cube-br, .sidebar-menu-btn.is-active .cube-br {
      animation: cubeAssembleBR 0.65s cubic-bezier(0.34, 1.56, 0.64, 1) 0.12s;
    }
    .sidebar-menu-btn:hover .cube-bl, .sidebar-menu-btn.is-active .cube-bl {
      animation: cubeAssembleBL 0.65s cubic-bezier(0.34, 1.56, 0.64, 1) 0.18s;
    }

    /* 2. CALENDARIO: Pasan las hojas */
    @keyframes calPageFlip {
      0% { transform: rotateX(0deg); opacity: 1; }
      30% { transform: rotateX(-80deg) translateY(-2px); opacity: 0.2; }
      60% { transform: rotateX(80deg) translateY(2px); opacity: 0.2; }
      100% { transform: rotateX(0deg) translateY(0); opacity: 1; }
    }
    @keyframes calHeaderJiggle {
      0%, 100% { transform: translateY(0); }
      40% { transform: translateY(-2.5px) scale(1.04); }
    }
    .sidebar-menu-btn:hover .icon-anim-calendar, .sidebar-menu-btn.is-active .icon-anim-calendar {
      animation: calHeaderJiggle 0.65s ease-in-out;
    }
    .sidebar-menu-btn:hover .cal-sheet-flipper, .sidebar-menu-btn.is-active .cal-sheet-flipper {
      animation: calPageFlip 0.7s cubic-bezier(0.4, 0, 0.2, 1);
    }

    /* 3. CARPETA / DRIVE: Se abre la carpeta */
    @keyframes folderOpenFlap {
      0% { transform: skewX(0deg) scaleY(1); opacity: 1; }
      45% { transform: skewX(-16deg) scaleY(0.68) translateY(2.5px); stroke-width: 2.2; }
      100% { transform: skewX(0deg) scaleY(1); opacity: 1; }
    }
    @keyframes folderBodyPop {
      0%, 100% { transform: scale(1); }
      45% { transform: scale(1.06) translateY(-1px); }
    }
    .sidebar-menu-btn:hover .icon-anim-drive, .sidebar-menu-btn.is-active .icon-anim-drive {
      animation: folderBodyPop 0.75s ease-in-out;
    }
    .sidebar-menu-btn:hover .drive-front, .sidebar-menu-btn.is-active .drive-front {
      animation: folderOpenFlap 0.75s cubic-bezier(0.34, 1.56, 0.64, 1);
    }

    /* 4. MARCAS / ETIQUETA: Levitando en el aire */
    @keyframes tagLevitation {
      0% { transform: translateY(0px) rotate(0deg); }
      25% { transform: translateY(-4px) rotate(-6deg) scale(1.06); filter: drop-shadow(0 4px 6px rgba(0, 112, 243, 0.4)); }
      50% { transform: translateY(-2px) rotate(4deg) scale(1.03); filter: drop-shadow(0 3px 5px rgba(0, 112, 243, 0.3)); }
      75% { transform: translateY(-5px) rotate(-3deg) scale(1.06); filter: drop-shadow(0 5px 8px rgba(0, 112, 243, 0.45)); }
      100% { transform: translateY(0px) rotate(0deg); filter: none; }
    }
    .sidebar-menu-btn:hover .icon-anim-brands, .sidebar-menu-btn.is-active .icon-anim-brands {
      animation: tagLevitation 1.5s ease-in-out infinite;
      transform-origin: center center;
    }

    /* 5. CONTENIDO: Publicando una publicación */
    @keyframes contentPublishPulse {
      0% { transform: scale(1) translateY(0); opacity: 1; }
      20% { transform: scale(0.82) translateY(3px); opacity: 0.6; }
      50% { transform: scale(1.18) translateY(-5px); opacity: 1; filter: drop-shadow(0 0 8px rgba(96, 165, 250, 0.9)); }
      75% { transform: scale(0.96) translateY(0); }
      100% { transform: scale(1) translateY(0); filter: none; }
    }
    .sidebar-menu-btn:hover .icon-anim-content, .sidebar-menu-btn.is-active .icon-anim-content {
      animation: contentPublishPulse 0.75s cubic-bezier(0.34, 1.56, 0.64, 1);
      transform-origin: center center;
    }

    /* 6. PROCESOS: Flechas girando */
    @keyframes processArrowsSpin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }
    .sidebar-menu-btn:hover .icon-anim-processes, .sidebar-menu-btn.is-active .icon-anim-processes {
      animation: processArrowsSpin 0.85s cubic-bezier(0.4, 0, 0.2, 1);
      transform-origin: center center;
    }

    /* 7. EQUIPO: Personitas llegando */
    @keyframes personLeftArrival {
      0% { transform: translateX(-9px) scale(0.85); opacity: 0.2; }
      60% { transform: translateX(2.5px) scale(1.08); opacity: 1; }
      80% { transform: translateX(-1px) scale(0.98); }
      100% { transform: translateX(0) scale(1); opacity: 1; }
    }
    @keyframes personRightArrival {
      0% { transform: translateX(9px) scale(0.85); opacity: 0.2; }
      60% { transform: translateX(-2.5px) scale(1.08); opacity: 1; }
      80% { transform: translateX(1px) scale(0.98); }
      100% { transform: translateX(0) scale(1); opacity: 1; }
    }
    .sidebar-menu-btn:hover .team-p-left, .sidebar-menu-btn.is-active .team-p-left {
      animation: personLeftArrival 0.65s cubic-bezier(0.34, 1.56, 0.64, 1);
    }
    .sidebar-menu-btn:hover .team-p-right, .sidebar-menu-btn.is-active .team-p-right {
      animation: personRightArrival 0.65s cubic-bezier(0.34, 1.56, 0.64, 1) 0.08s;
    }

    /* 8. CHARGE OPS: Rayo cayendo con flash eléctrico */
    @keyframes lightningDropStrike {
      0% { transform: translateY(-12px) scale(0.4); opacity: 0; filter: drop-shadow(0 0 0px #fbbf24); }
      25% { transform: translateY(0) scale(1.3); opacity: 1; filter: drop-shadow(0 0 16px #fbbf24) brightness(2); stroke: #ffffff; fill: #fbbf24; fill-opacity: 0.95; }
      40% { transform: translateY(-2px) scale(0.92); opacity: 0.7; filter: drop-shadow(0 0 4px #fbbf24); stroke: #fbbf24; fill-opacity: 0.4; }
      55% { transform: translateY(0) scale(1.18); opacity: 1; filter: drop-shadow(0 0 12px #fbbf24) brightness(1.6); fill-opacity: 0.85; }
      75% { transform: translateY(0) scale(1); opacity: 1; filter: drop-shadow(0 0 6px #fbbf24); fill-opacity: 0.5; }
      100% { transform: translateY(0) scale(1); opacity: 1; filter: none; stroke: #fbbf24; fill: #fbbf24; fill-opacity: 0.2; }
    }
    .sidebar-menu-btn:hover .charge-lightning, .sidebar-menu-btn.is-active .charge-lightning {
      animation: lightningDropStrike 0.8s ease-out;
      transform-origin: center top;
    }

        /* PRODUCCION: Dos engranajes girando */
    @keyframes gearSpinCW {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }
    @keyframes gearSpinCCW {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(-360deg); }
    }
    .sidebar-menu-btn:hover .gear-main, .sidebar-menu-btn.is-active .gear-main {
      animation: gearSpinCW 3s linear infinite;
    }
    .sidebar-menu-btn:hover .gear-sub, .sidebar-menu-btn.is-active .gear-sub {
      animation: gearSpinCCW 2.25s linear infinite;
    }

    /* CHAT & PRODUCCION EXTRAS */
    @keyframes chatBubblePulse {
      0%, 100% { transform: scale(1); }
      50% { transform: scale(1.12) rotate(-3deg); }
    }
    .sidebar-menu-btn:hover .icon-anim-chat, .sidebar-menu-btn.is-active .icon-anim-chat {
      animation: chatBubblePulse 0.6s ease-in-out;
      transform-origin: center center;
    }
    @keyframes prodClapperPlay {
      0%, 100% { transform: scale(1); }
      50% { transform: scale(1.12) rotate(4deg); }
    }
    .sidebar-menu-btn:hover .icon-anim-production, .sidebar-menu-btn.is-active .icon-anim-production {
      animation: prodClapperPlay 0.6s ease-in-out;
      transform-origin: center center;
    }

  `;
  document.head.appendChild(style);
}

// Timbre de notificación cristalino (Web Audio API)

const playWhatsAppSound = () => {
  try {
    const ctx = new (window.AudioContext || (window as any).webkitAudioContext)();
    [0, 0.12].forEach((t, i) => {
      const o = ctx.createOscillator();
      const g = ctx.createGain();
      o.connect(g); g.connect(ctx.destination);
      o.type = 'sine';
      o.frequency.value = i === 0 ? 1318.51 : 1760.00; // Mi6 -> La6
      g.gain.setValueAtTime(0.18, ctx.currentTime + t);
      g.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + t + 0.18);
      o.start(ctx.currentTime + t);
      o.stop(ctx.currentTime + t + 0.19);
    });
  } catch {}
};

const playCrystalChime = () => {
  try {
    const ctx = new (window.AudioContext || (window as any).webkitAudioContext)();
    [523.25, 659.25, 783.99, 1046.50].forEach((freq, i) => {
      const o = ctx.createOscillator();
      const g = ctx.createGain();
      o.connect(g); g.connect(ctx.destination);
      o.type = 'sine';
      o.frequency.value = freq;
      const t = ctx.currentTime + (i * 0.07);
      g.gain.setValueAtTime(0.22, t);
      g.gain.exponentialRampToValueAtTime(0.001, t + 0.35);
      o.start(t);
      o.stop(t + 0.36);
    });
  } catch {}
};

  const loadNotifications = async () => {
    try {
      const r = await api.get('/notifications');
      const notifs = Array.isArray(r.data) ? r.data : [];
      const newUnread = notifs.filter((n: any) => !n.read).length;
      if (newUnread > prevUnreadRef.current) playCrystalChime();
      prevUnreadRef.current = newUnread;
      try { sessionStorage.setItem('notifUnreadCount', String(newUnread)); } catch {}
      setNotifications(notifs);
    } catch {}
  };

  
  // Conexión Socket para Notificaciones en Vivo Instantáneas
  useEffect(() => {
    const socket = io('https://zoikanalyst.com', { path: '/socket.io', transports: ['websocket', 'polling'] });

    if (user?.id) {
      socket.emit('user:join', (user as any)?.userId || user?.id);
    }

    socket.on('notification:new', (notif: any) => {
      playCrystalChime();
      setNotifications(prev => [notif, ...prev.filter(n => n.id !== notif.id)]);
      toast.success(`🔔 ${notif.title || 'Nueva Notificación'}`);
    });

    socket.on('refresh:notifications', () => {
      loadNotifications();

    loadChatUnread();

    const handleChatReadEvent = () => {
      loadChatUnread();
    };
    window.addEventListener('chat:read', handleChatReadEvent);

    });

    
    socket.on('chat:push-notification', (data: any) => {
      if (!window.location.pathname.includes('/chat')) {
        playWhatsAppSound();
      }
      setChatToast(data);
      setChatUnreadCount(prev => prev + 1);
      if (chatToastTimer.current) clearTimeout(chatToastTimer.current);
      chatToastTimer.current = setTimeout(() => {
        setChatToast(null);
      }, 10000);
    });

    socket.on('chat:message', () => {
      loadChatNotifications();
    });

    return () => { socket.disconnect(); };
  }, [user?.id]);

    useEffect(() => {
    loadNotifications();

    loadChatUnread();

    const handleChatReadEvent = () => {
      loadChatUnread();
    };
    window.addEventListener('chat:read', handleChatReadEvent);

    loadChatNotifications();
    const interval = setInterval(loadNotifications, 60000);
    const chatInterval = setInterval(loadChatNotifications, 60000);
    return () => { clearInterval(interval); clearInterval(chatInterval); };
  }, []);

  useEffect(() => {
    const handler = (e: MouseEvent) => {
      if (notifRef.current && !notifRef.current.contains(e.target as Node)) setShowNotif(false);
      if (announcementsRef.current && !announcementsRef.current.contains(e.target as Node)) setShowAnnouncements(false);
    };
    if (showNotif || showAnnouncements) document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [showNotif, showAnnouncements]);

  const markRead = async (id: string) => {
    try {
      await api.put(`/notifications/${id}/read`);
      setNotifications(prev => prev.map(n => n.id === id ? { ...n, read: true } : n));
    } catch {}
  };

  
  const handleNotificationClick = (n: any) => {
    markRead(n.id);
    setShowNotif(false);

    if (n.link) {
      navigate(n.link);
      return;
    }

    const type = (n.type || "").toUpperCase();
    const title = (n.title || "").toLowerCase();
    const msg = (n.message || "").toLowerCase();

    // 1. PROCESOS
    if (type === "PROCESO" || type === "PROCESOS" || title.includes("proceso") || msg.includes("el proceso")) {
      const processId = n.pieceId ? n.pieceId.split("|").pop() : null;
      if (processId) {
        navigate(`/processes?processId=${processId}`, { state: { openProcessId: processId } });
      } else {
        navigate("/processes");
      }
      return;
    }

    // 2. ASIGNACIONES (Puede ser de Ficha dentro de Proceso o Pieza)
    if (type === "ASIGNACION" || title.includes("asignación") || title.includes("asignacion")) {
      if (n.pieceId && n.pieceId.includes("|")) {
        const [cardId, processId] = n.pieceId.split("|");
        navigate(`/processes?processId=${processId}&cardId=${cardId}`, {
          state: { openProcessId: processId, openCardId: cardId }
        });
        return;
      }
      if (title.includes("proceso") || msg.includes("proceso")) {
        const processId = n.pieceId || null;
        if (processId) {
          navigate(`/processes?processId=${processId}`, { state: { openProcessId: processId } });
        } else {
          navigate("/processes");
        }
        return;
      }
      if (n.pieceId) {
        navigate(`/content?pieceId=${n.pieceId}`, { state: { openPieceId: n.pieceId } });
        window.dispatchEvent(new CustomEvent("open-piece-modal", { detail: { pieceId: n.pieceId } }));
        return;
      }
    }

    // 3. MARCAS
    if (type === "MARCA" || title.includes("marca")) {
      navigate("/brands");
      return;
    }

    // 4. CHAT
    if (type === "CHAT" || title.includes("chat") || title.includes("mensaje")) {
      navigate("/chat");
      return;
    }

    // 5. SOLICITUDES
    if (type === "SOLICITUD" || title.includes("solicitud")) {
      navigate("/requests");
      return;
    }

    // 6. PIEZAS Y COMENTARIOS
    if (n.pieceId) {
      navigate(`/content?pieceId=${n.pieceId}`, { state: { openPieceId: n.pieceId } });
      window.dispatchEvent(new CustomEvent("open-piece-modal", { detail: { pieceId: n.pieceId } }));
      return;
    }

    // Fallback general
    navigate("/content");
  };

  const markAllRead = async () => {
    try {
      await api.put('/notifications/read-all');
      setNotifications(prev => prev.map(n => ({ ...n, read: true })));
    } catch {}
  };

  const isAlejandra = (user?.email || '').toLowerCase() === 'contabilidadzoikagency@gmail.com';
  const filteredMenu = MENU.filter(item => {
    if (!user || !item.roles.includes(user.role)) return false;
    if (isAlejandra) {
      // Para Alejandra nada más no deben aparecer: procesos, contenido, marca, ni charge ops
      const blockedPaths = ['/processes', '/content', '/production', '/brands', '/linkedin'];
      if (blockedPaths.includes(item.path)) return false;
    }
    return true;
  });
  
  // Estado de navegación móvil
  const [mobileDrawerOpen, setMobileDrawerOpen] = useState(false);
  useEffect(() => {
    setMobileDrawerOpen(false);
  }, [location.pathname]);

  const currentRouteObj = MENU.find(m => location.pathname.startsWith(m.path)) || { label: 'ZOIK Analyst', path: '/dashboard' };

  // Carga de Foto de Perfil Actualizada del Usuario
  const [showProfileEditModal, setShowProfileEditModal] = useState(false);
  const [profileAvatar, setProfileAvatar] = useState<string | null>(() => (user as any)?.avatar || null);

  useEffect(() => {
    // Purgar inmediatamente cualquier avatar global residual de sesiones anteriores
    try { localStorage.removeItem('userAvatar'); } catch {}

    if (user?.avatar) {
      setProfileAvatar(user.avatar);
    } else {
      setProfileAvatar(null);
    }

    if (user?.id) {
      api.get('/chat/me').then(r => {
        if (r.data?.avatar) {
          setProfileAvatar(r.data.avatar);
        } else {
          setProfileAvatar((user as any)?.avatar || null);
        }
      }).catch(() => {
        setProfileAvatar((user as any)?.avatar || null);
      });
    }
  }, [user?.id, user?.avatar]);

  const unreadCount = notifications.filter(n => !n.read).length;

  return (
    <>
    <aside className="zoik-desktop-only" style={{
      position: 'sticky',
      top: 0,
      left: 0,
      width: '74px',
      height: '100vh',
      maxHeight: '100vh',
      minHeight: '100vh',
      background: 'linear-gradient(180deg, #0070f3 0%, #0056d6 100%)',
      borderRight: '1px solid rgba(255, 255, 255, 0.15)',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '16px 0 14px',
      flexShrink: 0,
      zIndex: 100,
      userSelect: 'none',
      boxShadow: '4px 0 20px rgba(0, 80, 200, 0.15)',
      boxSizing: 'border-box',
      overflow: 'visible'
    }}>

      {/* SECCIÓN SUPERIOR: LOGO Y NAVEGACIÓN */}
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%', gap: '16px' }}>

        {/* LOGO DE ZOIK ORIGINAL */}
        <div
          onClick={() => navigate('/dashboard')}
          onMouseEnter={() => setHoveredItem('logo')}
          onMouseLeave={() => setHoveredItem(null)}
          style={{
            width: '46px',
            height: '46px',
            borderRadius: '14px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            position: 'relative',
            flexShrink: 0
          }}
        >
          <ZoikLogo size={44} />

          {hoveredItem === 'logo' && (
            <div style={{
              position: 'absolute',
              left: 'calc(100% + 14px)',
              top: '50%',
              transform: 'translateY(-50%)',
              background: 'rgba(5, 20, 50, 0.88)',
              backdropFilter: 'blur(20px)',
              WebkitBackdropFilter: 'blur(20px)',
              border: '1px solid rgba(255, 255, 255, 0.25)',
              boxShadow: '0 10px 30px rgba(0, 0, 0, 0.4), inset 0 1px 1px rgba(255, 255, 255, 0.2)',
              borderRadius: '10px',
              padding: '7px 14px',
              color: '#ffffff',
              fontSize: '12px',
              fontWeight: 800,
              whiteSpace: 'nowrap',
              zIndex: 9999999,
              pointerEvents: 'none',
              display: 'flex',
              alignItems: 'center',
              gap: '6px'
            }}>
              <span style={{ color: '#60a5fa' }}>ZOIK</span> | Analyst
            </div>
          )}
        </div>

        {/* LISTA DE MÓDULOS */}
        <nav style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '6px',
          width: '100%'
        }}>
          {filteredMenu.map(item => {
            const active = location.pathname.startsWith(item.path);
            const isHovered = hoveredItem === item.path;

            return (
              <div
                key={item.path}
                onMouseEnter={() => setHoveredItem(item.path)}
                onMouseLeave={() => setHoveredItem(null)}
                onClick={() => navigate(item.path)}
                style={{
                  position: 'relative',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: '100%',
                  height: '46px',
                  flexShrink: 0
                }}
              >
                {item.path === '/chat' && chatUnreadCount > 0 && (
                  <span style={{
                    position: 'absolute',
                    top: '2px',
                    right: '2px',
                    background: '#ef4444',
                    color: '#ffffff',
                    fontSize: '10px',
                    fontWeight: 900,
                    minWidth: '18px',
                    height: '18px',
                    padding: '0 4px',
                    borderRadius: '9px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    boxShadow: '0 0 10px rgba(239, 68, 68, 0.9), 0 2px 4px rgba(0,0,0,0.3)',
                    border: '2px solid #002878',
                    pointerEvents: 'none',
                    zIndex: 10
                  }}>
                    {chatUnreadCount > 99 ? '99+' : chatUnreadCount}
                  </span>
                )}

                <button
                  className={`sidebar-menu-btn ${active ? 'is-active' : ''}`}
                  style={{
                    width: '46px',
                    height: '46px',
                    borderRadius: '14px',
                    border: active ? '1px solid #ffffff' : '1px solid transparent',
                    background: active
                      ? '#ffffff'
                      : isHovered
                      ? 'rgba(255, 255, 255, 0.2)'
                      : 'transparent',
                    color: active ? '#0070f3' : isHovered ? '#ffffff' : 'rgba(255, 255, 255, 0.8)',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    transition: 'background 0.15s, color 0.15s',
                    boxShadow: active ? '0 4px 16px rgba(0, 40, 120, 0.25)' : 'none',
                    boxSizing: 'border-box'
                  }}
                >
                  {ICON_SVGS[item.path] || null}
                </button>

                {isHovered && (
                  <div style={{
                    position: 'absolute',
                    left: 'calc(100% + 14px)',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    background: 'rgba(5, 20, 50, 0.88)',
                    backdropFilter: 'blur(20px)',
                    WebkitBackdropFilter: 'blur(20px)',
                    border: '1px solid rgba(255, 255, 255, 0.25)',
                    boxShadow: '0 10px 30px rgba(0, 0, 0, 0.45), inset 0 1px 1px rgba(255, 255, 255, 0.2)',
                    borderRadius: '10px',
                    padding: '7px 14px',
                    color: '#ffffff',
                    fontSize: '12px',
                    fontWeight: 800,
                    whiteSpace: 'nowrap',
                    zIndex: 9999999,
                    pointerEvents: 'none',
                    letterSpacing: '0.3px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '6px'
                  }}>
                    {item.label}
                    {active && (
                      <span style={{ width: '6px', height: '6px', borderRadius: '50%', background: '#60a5fa' }} />
                    )}
                  </div>
                )}
              </div>
            );
          })}
        </nav>

      </div>

      {/* SECCIÓN INFERIOR: FIJA, SIN SALTOS NI PARPADEOS */}
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '8px',
        width: '100%',
        paddingTop: '10px',
        borderTop: '1px solid rgba(255, 255, 255, 0.12)',
        flexShrink: 0
      }}>

        {/* Avisos Generales / Buzón de Correo */}
        <div
          ref={announcementsRef}
          onMouseEnter={() => setHoveredItem('announcements')}
          onMouseLeave={() => setHoveredItem(null)}
          style={{ position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', height: '44px', flexShrink: 0 }}
        >
          <button
            onClick={() => {
              setShowAnnouncements(v => !v);
              setShowNotif(false);
            }}
            style={{
              width: '44px',
              height: '44px',
              borderRadius: '14px',
              border: showAnnouncements ? '1.5px solid #ffffff' : '1px solid rgba(255, 255, 255, 0.2)',
              background: showAnnouncements ? '#ffffff' : hoveredItem === 'announcements' ? 'rgba(255, 255, 255, 0.25)' : 'rgba(255, 255, 255, 0.12)',
              color: showAnnouncements ? '#0070f3' : '#ffffff',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              position: 'relative',
              transition: 'all 0.2s ease',
              boxSizing: 'border-box'
            }}
          >
            <svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <rect width="20" height="16" x="2" y="4" rx="2" />
              <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" />
            </svg>
          </button>

          {hoveredItem === 'announcements' && !showAnnouncements && (
            <div style={{
              position: 'absolute',
              left: 'calc(100% + 14px)',
              top: '50%',
              transform: 'translateY(-50%)',
              background: 'rgba(5, 20, 50, 0.88)',
              backdropFilter: 'blur(20px)',
              WebkitBackdropFilter: 'blur(20px)',
              border: '1px solid rgba(255, 255, 255, 0.25)',
              boxShadow: '0 10px 30px rgba(0, 0, 0, 0.5)',
              borderRadius: '10px',
              padding: '7px 14px',
              color: '#ffffff',
              fontSize: '12px',
              fontWeight: 800,
              whiteSpace: 'nowrap',
              zIndex: 9999999,
              pointerEvents: 'none'
            }}>
              Avisos Generales
            </div>
          )}

          {/* Panel Avisos Generales */}
          {showAnnouncements && (
            <div style={{
              position: 'absolute',
              left: 'calc(100% + 16px)',
              bottom: '0px',
              width: '320px',
              maxHeight: '420px',
              background: '#ffffff',
              borderRadius: '16px',
              boxShadow: '0 20px 50px rgba(0,0,0,0.25)',
              border: '1px solid rgba(15, 42, 74, 0.1)',
              overflow: 'hidden',
              zIndex: 9999999,
              display: 'flex',
              flexDirection: 'column',
              fontFamily: '"Montserrat", sans-serif',
              animation: 'zoikFadeIn 0.2s ease-out'
            }}>
              <div style={{ padding: '14px 18px', borderBottom: '1px solid #f1f5f9', display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: '#fafbfc' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <span style={{ fontSize: '15px' }}>📬</span>
                  <span style={{ fontWeight: 900, fontSize: '13px', color: '#0f2a4a' }}>Avisos Generales</span>
                </div>
                <span style={{ fontSize: '10px', fontWeight: 800, color: '#0070f3', background: 'rgba(0, 112, 243, 0.1)', padding: '2px 8px', borderRadius: '10px' }}>
                  Plataforma
                </span>
              </div>
              <div style={{ overflowY: 'auto', flex: 1, padding: '14px 16px', display: 'flex', flexDirection: 'column', gap: '10px' }}>
                <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px', padding: '12px 14px', background: 'linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)', borderRadius: '14px', border: '1px solid #e2e8f0', boxShadow: '0 2px 6px rgba(15, 42, 74, 0.03)' }}>
                  <span style={{ fontSize: '16px', marginTop: '2px', flexShrink: 0 }}>🔔</span>
                  <div style={{ fontSize: '12px', color: '#0f2a4a', lineHeight: 1.45 }}>
                    <strong style={{ color: '#0070f3' }}>Zoik Platform</strong> actualizó las políticas de entrega para hoy.
                  </div>
                </div>

                <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px', padding: '12px 14px', background: 'linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)', borderRadius: '14px', border: '1px solid #e2e8f0', boxShadow: '0 2px 6px rgba(15, 42, 74, 0.03)' }}>
                  <span style={{ fontSize: '16px', marginTop: '2px', flexShrink: 0 }}>💬</span>
                  <div style={{ fontSize: '12px', color: '#0f2a4a', lineHeight: 1.45 }}>
                    Nuevos comentarios de clientes en el módulo de <strong style={{ color: '#0f2a4a' }}>Contenido</strong>.
                  </div>
                </div>

                <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px', padding: '12px 14px', background: 'linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)', borderRadius: '14px', border: '1px solid #e2e8f0', boxShadow: '0 2px 6px rgba(15, 42, 74, 0.03)' }}>
                  <span style={{ fontSize: '16px', marginTop: '2px', flexShrink: 0 }}>📢</span>
                  <div style={{ fontSize: '12px', color: '#0f2a4a', lineHeight: 1.45 }}>
                    Canales y grupos sincronizados en tiempo real para todo el equipo.
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>

        {/* Notificaciones */}
        <div
          ref={notifRef}
          onMouseEnter={() => setHoveredItem('notif')}
          onMouseLeave={() => setHoveredItem(null)}
          style={{ position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', height: '44px', flexShrink: 0 }}
        >
          <button
            onClick={() => { setShowNotif(v => !v); setShowAnnouncements(false); }}
            style={{
              width: '44px',
              height: '44px',
              borderRadius: '14px',
              border: showNotif ? '1.5px solid #ffffff' : unreadCount > 0 ? '1.5px solid #0070f3' : '1px solid rgba(255, 255, 255, 0.2)',
              background: showNotif ? '#ffffff' : unreadCount > 0 ? '#0070f3' : hoveredItem === 'notif' ? 'rgba(255, 255, 255, 0.25)' : 'rgba(255, 255, 255, 0.12)',
              color: showNotif ? '#0070f3' : '#ffffff',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              position: 'relative',
              transition: 'all 0.2s ease',
              boxSizing: 'border-box',
              animation: unreadCount > 0 && !showNotif ? 'bellGlowPulse 1.8s infinite ease-in-out' : 'none'
            }}
          >
            <svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
              <path d="M13.73 21a2 2 0 0 1-3.46 0" />
            </svg>
            {unreadCount > 0 && (
              <span style={{
                position: 'absolute',
                top: '6px',
                right: '6px',
                width: '8px',
                height: '8px',
                borderRadius: '50%',
                background: '#ef4444',
                boxShadow: '0 0 8px #ef4444'
              }} />
            )}
          </button>

          {hoveredItem === 'notif' && !showNotif && (
            <div style={{
              position: 'absolute',
              left: 'calc(100% + 14px)',
              top: '50%',
              transform: 'translateY(-50%)',
              background: 'rgba(5, 20, 50, 0.88)',
              backdropFilter: 'blur(20px)',
              WebkitBackdropFilter: 'blur(20px)',
              border: '1px solid rgba(255, 255, 255, 0.25)',
              boxShadow: '0 10px 30px rgba(0, 0, 0, 0.5)',
              borderRadius: '10px',
              padding: '7px 14px',
              color: '#ffffff',
              fontSize: '12px',
              fontWeight: 800,
              whiteSpace: 'nowrap',
              zIndex: 9999999,
              pointerEvents: 'none'
            }}>
              Notificaciones {unreadCount > 0 ? `(${unreadCount})` : ''}
            </div>
          )}

          {/* Panel Notificaciones */}
          {showNotif && (
            <div style={{
              position: 'absolute',
              left: 'calc(100% + 16px)',
              bottom: '0px',
              width: '320px',
              maxHeight: '400px',
              background: '#ffffff',
              borderRadius: '16px',
              boxShadow: '0 20px 50px rgba(0,0,0,0.25)',
              border: '1px solid rgba(15, 42, 74, 0.1)',
              overflow: 'hidden',
              zIndex: 9999999,
              display: 'flex',
              flexDirection: 'column'
            }}>
              <div style={{ padding: '14px 18px', borderBottom: '1px solid #f1f5f9', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <span style={{ fontWeight: 900, fontSize: '13px', color: '#0f2a4a' }}>Notificaciones</span>
                {unreadCount > 0 && (
                  <button onClick={markAllRead} style={{ background: 'none', border: 'none', color: '#0070f3', fontSize: '11px', fontWeight: 700, cursor: 'pointer' }}>
                    Marcar leídas
                  </button>
                )}
              </div>
              <div style={{ overflowY: 'auto', flex: 1, maxHeight: '340px' }}>
                {notifications.length === 0 ? (
                  <div style={{ padding: '30px', textAlign: 'center', color: 'rgba(15,42,74,0.3)', fontSize: '12px' }}>
                    Sin notificaciones
                  </div>
                ) : (
                  notifications.slice(0, 15).map(n => (
                    <div
                      key={n.id}
                      onClick={() => handleNotificationClick(n)}
                      style={{
                        padding: '12px 16px',
                        borderBottom: '1px solid #f8fafc',
                        background: n.read ? 'white' : 'rgba(0,112,243,0.06)',
                        cursor: 'pointer',
                        display: 'flex',
                        gap: '10px',
                        alignItems: 'flex-start'
                      }}
                    >
                      <span style={{ fontSize: '15px', marginTop: '2px' }}>{NOTIF_ICONS[n.type] || '🔔'}</span>
                      <div style={{ flex: 1, minWidth: 0 }}>
                        <div style={{ fontSize: '12px', fontWeight: n.read ? 700 : 900, color: '#0f2a4a', lineHeight: 1.3 }}>
                          {n.title || 'Notificación'}
                        </div>
                        {n.message && n.message !== n.title && (
                          <div style={{ fontSize: '11px', fontWeight: 600, color: '#0070f3', marginTop: '2px', lineHeight: 1.35, wordBreak: 'break-word' }}>
                            {n.message}
                          </div>
                        )}
                        <div style={{ fontSize: '10px', color: 'rgba(15,42,74,0.45)', marginTop: '3px', fontWeight: 700 }}>
                          {timeAgo(n.createdAt)}
                        </div>
                      </div>
                    </div>
                  ))
                )}
              </div>
            </div>
          )}
        </div>

        {/* Perfil */}
        <div
          onMouseEnter={() => setHoveredItem('profile')}
          onMouseLeave={() => setHoveredItem(null)}
          style={{ position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', height: '42px', flexShrink: 0 }}
        >
          <div
            onClick={() => setShowProfileEditModal(true)}
            style={{
              width: '42px',
              height: '42px',
              borderRadius: '50%',
              background: '#ffffff',
              border: '2px solid rgba(255, 255, 255, 0.9)',
              overflow: 'hidden',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: '#0070f3',
              fontSize: '13px',
              fontWeight: 900,
              boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
              boxSizing: 'border-box'
            }}
          >
            {profileAvatar ? (
              <img src={profileAvatar} alt="Perfil" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
            ) : (
              (user?.firstName?.[0] || 'U')
            )}
          </div>

          {hoveredItem === 'profile' && (
            <div style={{
              position: 'absolute',
              left: 'calc(100% + 14px)',
              top: '50%',
              transform: 'translateY(-50%)',
              background: 'rgba(5, 20, 50, 0.88)',
              backdropFilter: 'blur(20px)',
              WebkitBackdropFilter: 'blur(20px)',
              border: '1px solid rgba(255, 255, 255, 0.25)',
              boxShadow: '0 10px 30px rgba(0, 0, 0, 0.5)',
              borderRadius: '10px',
              padding: '8px 14px',
              color: '#ffffff',
              fontSize: '12px',
              fontWeight: 800,
              whiteSpace: 'nowrap',
              zIndex: 9999999,
              pointerEvents: 'none'
            }}>
              <div>{user?.firstName} {user?.lastName}</div>
              <div style={{ fontSize: '10px', color: '#60a5fa', fontWeight: 700 }}>
                {ROLE_LABELS[user?.role || ''] || user?.role}
              </div>
              <div style={{ fontSize: '9px', color: '#93c5fd', marginTop: '3px', fontWeight: 700 }}>
                ✏️ Clic para editar mis datos
              </div>
            </div>
          )}
        </div>

        {/* Cerrar Sesión */}
        <div
          onMouseEnter={() => setHoveredItem('logout')}
          onMouseLeave={() => setHoveredItem(null)}
          style={{ position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', height: '36px', flexShrink: 0 }}
        >
          <button
            onClick={logout}
            style={{
              width: '36px',
              height: '36px',
              borderRadius: '10px',
              border: 'none',
              background: hoveredItem === 'logout' ? 'rgba(239, 68, 68, 0.35)' : 'transparent',
              color: hoveredItem === 'logout' ? '#ffffff' : 'rgba(255, 255, 255, 0.7)',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              transition: 'background 0.15s, color 0.15s',
              boxSizing: 'border-box'
            }}
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
              <polyline points="16 17 21 12 16 7" />
              <line x1="21" y1="12" x2="9" y2="12" />
            </svg>
          </button>

          {hoveredItem === 'logout' && (
            <div style={{
              position: 'absolute',
              left: 'calc(100% + 14px)',
              top: '50%',
              transform: 'translateY(-50%)',
              background: 'rgba(239, 68, 68, 0.92)',
              backdropFilter: 'blur(16px)',
              WebkitBackdropFilter: 'blur(16px)',
              border: '1px solid rgba(255, 255, 255, 0.25)',
              boxShadow: '0 10px 30px rgba(0, 0, 0, 0.4)',
              borderRadius: '10px',
              padding: '6px 12px',
              color: '#ffffff',
              fontSize: '11px',
              fontWeight: 800,
              whiteSpace: 'nowrap',
              zIndex: 9999999,
              pointerEvents: 'none'
            }}>
              Cerrar Sesión
            </div>
          )}
        </div>

      </div>

      {/* Toast Chat Flotante Estilo Apple (Top Right - 10 Segundos) */}
      {chatToast && (
        <div
          onClick={() => { navigate('/chat'); setChatToast(null); }}
          style={{
            position: 'fixed',
            top: '24px',
            right: '24px',
            background: 'rgba(255, 255, 255, 0.86)',
            backdropFilter: 'blur(30px) saturate(190%)',
            WebkitBackdropFilter: 'blur(30px) saturate(190%)',
            border: '1px solid rgba(255, 255, 255, 0.95)',
            boxShadow: '0 18px 40px -8px rgba(15, 42, 74, 0.18), 0 4px 16px rgba(15, 42, 74, 0.06), inset 0 1px 1.5px rgba(255, 255, 255, 0.98)',
            borderRadius: '22px',
            padding: '12px 16px 14px 16px',
            color: '#0f2a4a',
            cursor: 'pointer',
            zIndex: 999999999,
            display: 'flex',
            flexDirection: 'column',
            gap: '8px',
            width: '340px',
            fontFamily: '"Montserrat", -apple-system, sans-serif',
            animation: 'appleToastEnter 0.35s cubic-bezier(0.16, 1, 0.3, 1)',
            transition: 'transform 0.2s cubic-bezier(0.16, 1, 0.3, 1), box-shadow 0.2s ease',
            boxSizing: 'border-box'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = 'translateY(-2px) scale(1.01)';
            e.currentTarget.style.boxShadow = '0 22px 48px -6px rgba(15, 42, 74, 0.22), 0 6px 20px rgba(15, 42, 74, 0.08), inset 0 1px 1.5px rgba(255, 255, 255, 0.98)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = 'translateY(0) scale(1)';
            e.currentTarget.style.boxShadow = '0 18px 40px -8px rgba(15, 42, 74, 0.18), 0 4px 16px rgba(15, 42, 74, 0.06), inset 0 1px 1.5px rgba(255, 255, 255, 0.98)';
          }}
        >
          {/* Apple Header */}
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
              <div style={{
                width: '18px',
                height: '18px',
                borderRadius: '6px',
                background: 'linear-gradient(135deg, #0070f3, #0f2a4a)',
                color: 'white',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '10px',
                fontWeight: 900,
                boxShadow: '0 2px 5px rgba(0, 112, 243, 0.3)'
              }}>
                <svg width="10" height="10" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 9h12v2H6V9zm8 5H6v-2h8v2zm4-6H6V6h12v2z"/>
                </svg>
              </div>
              <span style={{ fontSize: '10.5px', fontWeight: 800, letterSpacing: '0.5px', color: 'rgba(15, 42, 74, 0.55)', textTransform: 'uppercase' }}>
                MENSAJES
              </span>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <span style={{ fontSize: '10px', fontWeight: 600, color: 'rgba(15, 42, 74, 0.4)' }}>
                ahora
              </span>
              <button
                onClick={(e) => { e.stopPropagation(); setChatToast(null); }}
                title="Cerrar notificación"
                style={{
                  width: '18px',
                  height: '18px',
                  borderRadius: '50%',
                  background: 'rgba(15, 42, 74, 0.08)',
                  border: 'none',
                  color: 'rgba(15, 42, 74, 0.6)',
                  fontSize: '10px',
                  fontWeight: 800,
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  padding: 0,
                  transition: 'all 0.15s ease'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = 'rgba(15, 42, 74, 0.15)';
                  e.currentTarget.style.color = '#0f2a4a';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = 'rgba(15, 42, 74, 0.08)';
                  e.currentTarget.style.color = 'rgba(15, 42, 74, 0.6)';
                }}
              >
                ✕
              </button>
            </div>
          </div>

          {/* Apple Message Body */}
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginTop: '2px' }}>
            <div style={{
              width: '40px',
              height: '40px',
              borderRadius: '50%',
              background: 'linear-gradient(135deg, #0070f3, #0051b3)',
              color: 'white',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '14px',
              fontWeight: 900,
              overflow: 'hidden',
              flexShrink: 0,
              boxShadow: '0 4px 10px rgba(0, 112, 243, 0.25)',
              border: '1.5px solid rgba(255, 255, 255, 0.9)'
            }}>
              {chatToast.senderAvatar ? (
                <img src={chatToast.senderAvatar} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
              ) : (
                chatToast.senderName?.[0] || '💬'
              )}
            </div>

            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ fontSize: '13px', fontWeight: 800, color: '#0f2a4a', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', letterSpacing: '-0.2px' }}>
                {chatToast.senderName}
              </div>
              <div style={{
                fontSize: '12px',
                fontWeight: 500,
                color: 'rgba(15, 42, 74, 0.75)',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                display: '-webkit-box',
                WebkitLineClamp: 2,
                WebkitBoxOrient: 'vertical',
                lineHeight: '1.4',
                marginTop: '1px'
              }}>
                {chatToast.preview}
              </div>
            </div>
          </div>
        </div>
      )}

    </aside>

    {/* ========================================================================== */}
    {/* SISTEMA DE NAVEGACIÓN MÓVIL (TOP BAR, BOTTOM BAR & SLIDE-OVER DRAWER)     */}
    {/* ========================================================================== */}
    <div className="zoik-mobile-only">
      
      {/* 1. BARRA SUPERIOR FIJA (TOP APP BAR MÓVIL) */}
      <header style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        height: 'calc(56px + var(--sat))',
        paddingTop: 'var(--sat)',
        paddingLeft: '14px',
        paddingRight: '14px',
        background: 'linear-gradient(135deg, rgba(0, 112, 243, 0.96) 0%, rgba(0, 80, 204, 0.94) 100%)',
        backdropFilter: 'blur(20px) saturate(180%)',
        WebkitBackdropFilter: 'blur(20px) saturate(180%)',
        borderBottom: '1px solid rgba(255, 255, 255, 0.2)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        zIndex: 990,
        boxShadow: '0 4px 20px rgba(0, 80, 200, 0.18)',
        boxSizing: 'border-box'
      }}>
        {/* Lado Izquierdo: Logo & Título de Página */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <div
            onClick={() => navigate('/dashboard')}
            style={{ width: '34px', height: '34px', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }}
          >
            <ZoikLogo size={32} />
          </div>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <span style={{ fontSize: '15px', fontWeight: 900, color: '#ffffff', letterSpacing: '-0.3px', lineHeight: 1.2 }}>
              {currentRouteObj.label}
            </span>
            <span style={{ fontSize: '9.5px', fontWeight: 700, color: 'rgba(255,255,255,0.7)', letterSpacing: '0.4px', textTransform: 'uppercase' }}>
              ZOIK Analyst
            </span>
          </div>
        </div>

        {/* Lado Derecho: Campana, Avatar y Hamburguesa */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          {/* Campana de Notificaciones */}
          <button
            onClick={() => setShowNotif(prev => !prev)}
            title="Notificaciones"
            style={{
              position: 'relative',
              width: '36px',
              height: '36px',
              borderRadius: '10px',
              border: '1px solid rgba(255, 255, 255, 0.25)',
              background: showNotif ? 'rgba(255, 255, 255, 0.25)' : 'rgba(255, 255, 255, 0.12)',
              color: '#ffffff',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              cursor: 'pointer'
            }}
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
              <path d="M13.73 21a2 2 0 0 1-3.46 0" />
            </svg>
            {unreadCount > 0 && (
              <span style={{
                position: 'absolute',
                top: '-3px',
                right: '-3px',
                background: '#ef4444',
                color: 'white',
                fontSize: '9px',
                fontWeight: 900,
                width: '16px',
                height: '16px',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                boxShadow: '0 2px 6px rgba(239, 68, 68, 0.5)',
                border: '1.5px solid #ffffff'
              }}>
                {unreadCount > 9 ? '9+' : unreadCount}
              </span>
            )}
          </button>

          {/* Avatar de Usuario */}
          <div
            onClick={() => navigate('/team')}
            style={{
              width: '34px',
              height: '34px',
              borderRadius: '50%',
              background: '#ffffff',
              border: '1.5px solid rgba(255, 255, 255, 0.9)',
              overflow: 'hidden',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: '#0070f3',
              fontSize: '12px',
              fontWeight: 900,
              flexShrink: 0
            }}
          >
            {profileAvatar ? (
              <img src={profileAvatar} alt="Perfil" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
            ) : (
              (user?.firstName?.[0] || 'U')
            )}
          </div>

          {/* Botón Menú Hamburguesa */}
          <button
            onClick={() => setMobileDrawerOpen(prev => !prev)}
            title="Abrir Menú"
            style={{
              width: '36px',
              height: '36px',
              borderRadius: '10px',
              border: '1px solid rgba(255, 255, 255, 0.25)',
              background: mobileDrawerOpen ? 'rgba(255, 255, 255, 0.3)' : 'rgba(255, 255, 255, 0.15)',
              color: '#ffffff',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              cursor: 'pointer'
            }}
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
              {mobileDrawerOpen ? (
                <>
                  <line x1="18" y1="6" x2="6" y2="18" />
                  <line x1="6" y1="6" x2="18" y2="18" />
                </>
              ) : (
                <>
                  <line x1="4" y1="7" x2="20" y2="7" />
                  <line x1="4" y1="12" x2="20" y2="12" />
                  <line x1="4" y1="17" x2="20" y2="17" />
                </>
              )}
            </svg>
          </button>
        </div>
      </header>

      {/* 2. BARRA DE NAVEGACIÓN INFERIOR (BOTTOM NAV MÓVIL) */}
      {/* 2. BARRA DE NAVEGACIÓN INFERIOR (BOTTOM NAV MÓVIL ESTILO APPLE DOCK) */}
      <nav style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        height: 'calc(60px + var(--sab))',
        paddingBottom: 'var(--sab)',
        background: 'rgba(255, 255, 255, 0.94)',
        backdropFilter: 'blur(28px) saturate(200%)',
        WebkitBackdropFilter: 'blur(28px) saturate(200%)',
        borderTop: '1px solid rgba(255, 255, 255, 0.9)',
        boxShadow: '0 -4px 25px rgba(15, 42, 74, 0.08), 0 -1px 4px rgba(15, 42, 74, 0.03)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-around',
        zIndex: 990,
        boxSizing: 'border-box'
      }}>
        {/* Botón 1: Dashboard */}
        {(() => {
          const isAct = location.pathname.startsWith('/dashboard');
          return (
            <button
              onClick={() => navigate('/dashboard')}
              style={{
                flex: 1,
                height: '100%',
                background: 'none',
                border: 'none',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '2px',
                color: isAct ? '#0070f3' : '#64748b',
                cursor: 'pointer',
                padding: '4px 0',
                transition: 'all 0.2s cubic-bezier(0.16, 1, 0.3, 1)'
              }}
            >
              <div style={{
                padding: '4px 14px',
                borderRadius: '16px',
                background: isAct ? 'rgba(0, 112, 243, 0.12)' : 'transparent',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                transition: 'all 0.2s ease'
              }}>
                <div style={{ transform: 'scale(0.95)' }}>{ICON_SVGS['/dashboard']}</div>
              </div>
              <span style={{ fontSize: '10px', fontWeight: isAct ? 800 : 600, letterSpacing: '-0.2px' }}>
                Dashboard
              </span>
            </button>
          );
        })()}

        {/* Botón 2: Chat */}
        {(() => {
          const isAct = location.pathname.startsWith('/chat');
          return (
            <button
              onClick={() => navigate('/chat')}
              style={{
                flex: 1,
                height: '100%',
                background: 'none',
                border: 'none',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '2px',
                color: isAct ? '#0070f3' : '#64748b',
                cursor: 'pointer',
                padding: '4px 0',
                position: 'relative',
                transition: 'all 0.2s cubic-bezier(0.16, 1, 0.3, 1)'
              }}
            >
              <div style={{
                padding: '4px 14px',
                borderRadius: '16px',
                background: isAct ? 'rgba(0, 112, 243, 0.12)' : 'transparent',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                position: 'relative',
                transition: 'all 0.2s ease'
              }}>
                <div style={{ transform: 'scale(0.95)', position: 'relative' }}>
                  {ICON_SVGS['/chat']}
                  {chatUnreadCount > 0 && (
                    <span style={{
                      position: 'absolute',
                      top: '-4px',
                      right: '-8px',
                      background: '#ef4444',
                      color: 'white',
                      fontSize: '9px',
                      fontWeight: 900,
                      padding: '1px 5px',
                      borderRadius: '10px',
                      lineHeight: 1,
                      border: '1.5px solid #ffffff',
                      boxShadow: '0 2px 5px rgba(239, 68, 68, 0.4)'
                    }}>
                      {chatUnreadCount > 9 ? '9+' : chatUnreadCount}
                    </span>
                  )}
                </div>
              </div>
              <span style={{ fontSize: '10px', fontWeight: isAct ? 800 : 600, letterSpacing: '-0.2px' }}>
                Chat
              </span>
            </button>
          );
        })()}

        {/* Botón 3: Producción / Contenido */}
        {(() => {
          const isAct = location.pathname.startsWith('/production') || location.pathname.startsWith('/content');
          const targetPath = user?.role === 'ADMIN' ? '/production' : '/content';
          return (
            <button
              onClick={() => navigate(targetPath)}
              style={{
                flex: 1,
                height: '100%',
                background: 'none',
                border: 'none',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '2px',
                color: isAct ? '#0070f3' : '#64748b',
                cursor: 'pointer',
                padding: '4px 0',
                transition: 'all 0.2s cubic-bezier(0.16, 1, 0.3, 1)'
              }}
            >
              <div style={{
                padding: '4px 14px',
                borderRadius: '16px',
                background: isAct ? 'rgba(0, 112, 243, 0.12)' : 'transparent',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                transition: 'all 0.2s ease'
              }}>
                <div style={{ transform: 'scale(0.95)' }}>
                  {user?.role === 'ADMIN' ? ICON_SVGS['/production'] : ICON_SVGS['/content']}
                </div>
              </div>
              <span style={{ fontSize: '10px', fontWeight: isAct ? 800 : 600, letterSpacing: '-0.2px' }}>
                {user?.role === 'ADMIN' ? 'Producción' : 'Contenido'}
              </span>
            </button>
          );
        })()}

        {/* Botón 4: Procesos */}
        {(() => {
          const isAct = location.pathname.startsWith('/processes');
          return (
            <button
              onClick={() => navigate('/processes')}
              style={{
                flex: 1,
                height: '100%',
                background: 'none',
                border: 'none',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '2px',
                color: isAct ? '#0070f3' : '#64748b',
                cursor: 'pointer',
                padding: '4px 0',
                transition: 'all 0.2s cubic-bezier(0.16, 1, 0.3, 1)'
              }}
            >
              <div style={{
                padding: '4px 14px',
                borderRadius: '16px',
                background: isAct ? 'rgba(0, 112, 243, 0.12)' : 'transparent',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                transition: 'all 0.2s ease'
              }}>
                <div style={{ transform: 'scale(0.95)' }}>{ICON_SVGS['/processes']}</div>
              </div>
              <span style={{ fontSize: '10px', fontWeight: isAct ? 800 : 600, letterSpacing: '-0.2px' }}>
                Procesos
              </span>
            </button>
          );
        })()}

        {/* Botón 5: Más / Drawer */}
        <button
          onClick={() => setMobileDrawerOpen(true)}
          style={{
            flex: 1,
            height: '100%',
            background: 'none',
            border: 'none',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '2px',
            color: mobileDrawerOpen ? '#0070f3' : '#64748b',
            cursor: 'pointer',
            padding: '4px 0',
            transition: 'all 0.2s cubic-bezier(0.16, 1, 0.3, 1)'
          }}
        >
          <div style={{
            padding: '4px 14px',
            borderRadius: '16px',
            background: mobileDrawerOpen ? 'rgba(0, 112, 243, 0.12)' : 'transparent',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            transition: 'all 0.2s ease'
          }}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="12" r="1.5" fill="currentColor" />
              <circle cx="6" cy="12" r="1.5" fill="currentColor" />
              <circle cx="18" cy="12" r="1.5" fill="currentColor" />
            </svg>
          </div>
          <span style={{ fontSize: '10px', fontWeight: mobileDrawerOpen ? 800 : 600, letterSpacing: '-0.2px' }}>
            Más
          </span>
        </button>
      </nav>

      {/* 3. DRAWER LATERAL DESPLEGABLE MÓVIL (SLIDE-OVER MENU ESTILO APPLE/MATERIAL 3) */}
      {mobileDrawerOpen && (
        <div
          onClick={() => setMobileDrawerOpen(false)}
          style={{
            position: 'fixed',
            inset: 0,
            background: 'rgba(15, 42, 74, 0.65)',
            backdropFilter: 'blur(12px)',
            WebkitBackdropFilter: 'blur(12px)',
            zIndex: 1000,
            display: 'flex',
            animation: 'zoikFadeIn 0.2s ease-out'
          }}
        >
          <div
            onClick={e => e.stopPropagation()}
            style={{
              width: '86%',
              maxWidth: '340px',
              height: '100%',
              background: 'linear-gradient(180deg, #0070f3 0%, #0056d6 60%, #0f2a4a 100%)',
              boxShadow: '8px 0 36px rgba(0,0,0,0.35)',
              display: 'flex',
              flexDirection: 'column',
              padding: 'calc(18px + var(--sat)) 18px calc(20px + var(--sab))',
              boxSizing: 'border-box',
              overflowY: 'auto',
              borderRadius: '0 28px 28px 0',
              animation: 'zoikSlideInLeft 0.28s cubic-bezier(0.16, 1, 0.3, 1)'
            }}
          >
            {/* Header de Usuario en Drawer */}
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '12px',
              paddingBottom: '16px',
              borderBottom: '1px solid rgba(255, 255, 255, 0.2)',
              marginBottom: '14px'
            }}>
              <div style={{ position: 'relative' }}>
                <div style={{
                  width: '48px',
                  height: '48px',
                  borderRadius: '50%',
                  background: '#ffffff',
                  border: '2px solid rgba(255, 255, 255, 0.95)',
                  overflow: 'hidden',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: '#0070f3',
                  fontSize: '17px',
                  fontWeight: 900,
                  flexShrink: 0,
                  boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
                }}>
                  {profileAvatar ? (
                    <img src={profileAvatar} alt="Perfil" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                  ) : (
                    (user?.firstName?.[0] || 'U')
                  )}
                </div>
                {/* Dot de presencia */}
                <div style={{
                  position: 'absolute',
                  bottom: '1px',
                  right: '1px',
                  width: '12px',
                  height: '12px',
                  borderRadius: '50%',
                  background: MOBILE_STATUS_CONFIG[mobilePresence]?.color || '#10b981',
                  border: '2px solid #ffffff',
                  boxShadow: '0 1px 4px rgba(0,0,0,0.2)'
                }} />
              </div>

              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontSize: '15px', fontWeight: 900, color: '#ffffff', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                  {user?.firstName} {user?.lastName}
                </div>
                <div style={{ fontSize: '11px', color: 'rgba(255,255,255,0.8)', fontWeight: 600 }}>
                  {ROLE_LABELS[user?.role || ''] || user?.role}
                </div>
              </div>

              <button
                onClick={() => setMobileDrawerOpen(false)}
                style={{
                  background: 'rgba(255, 255, 255, 0.18)',
                  border: 'none',
                  color: '#ffffff',
                  width: '32px',
                  height: '32px',
                  borderRadius: '50%',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '14px',
                  fontWeight: 900
                }}
              >
                ✕
              </button>
            </div>

            {/* Selector Rápido de Estado en Drawer */}
            <div style={{
              background: 'rgba(255, 255, 255, 0.14)',
              borderRadius: '14px',
              padding: '8px 10px',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginBottom: '16px',
              border: '1px solid rgba(255, 255, 255, 0.2)'
            }}>
              {(['ONLINE', 'BUSY', 'OFFLINE'] as const).map(stKey => {
                const isSelected = mobilePresence === stKey;
                const conf = MOBILE_STATUS_CONFIG[stKey];
                return (
                  <button
                    key={stKey}
                    onClick={() => setMobilePresence(stKey)}
                    style={{
                      flex: 1,
                      padding: '6px 4px',
                      borderRadius: '10px',
                      border: 'none',
                      background: isSelected ? 'rgba(255, 255, 255, 0.95)' : 'transparent',
                      color: isSelected ? '#0f2a4a' : 'rgba(255, 255, 255, 0.85)',
                      fontSize: '11px',
                      fontWeight: isSelected ? 800 : 600,
                      cursor: 'pointer',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '4px',
                      transition: 'all 0.2s ease',
                      boxShadow: isSelected ? '0 2px 8px rgba(0,0,0,0.1)' : 'none'
                    }}
                  >
                    <span style={{ fontSize: '12px' }}>{conf.emoji}</span>
                    <span>{conf.label}</span>
                  </button>
                );
              })}
            </div>

            {/* Lista Completa de Módulos */}
            <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', flex: 1 }}>
              <span style={{ fontSize: '10px', fontWeight: 800, color: 'rgba(255,255,255,0.65)', textTransform: 'uppercase', letterSpacing: '0.6px', marginBottom: '6px' }}>
                Módulos de la Plataforma
              </span>
              {filteredMenu.map(item => {
                const active = location.pathname.startsWith(item.path);
                return (
                  <div
                    key={item.path}
                    onClick={() => {
                      navigate(item.path);
                      setMobileDrawerOpen(false);
                    }}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '12px',
                      padding: '11px 14px',
                      borderRadius: '14px',
                      background: active ? 'rgba(255, 255, 255, 0.25)' : 'rgba(255, 255, 255, 0.06)',
                      color: '#ffffff',
                      cursor: 'pointer',
                      fontSize: '13.5px',
                      fontWeight: active ? 900 : 600,
                      border: active ? '1px solid rgba(255, 255, 255, 0.4)' : '1px solid rgba(255, 255, 255, 0.08)',
                      transition: 'all 0.15s ease',
                      backdropFilter: 'blur(8px)'
                    }}
                  >
                    <div style={{ width: '22px', height: '22px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      {ICON_SVGS[item.path]}
                    </div>
                    <span style={{ flex: 1 }}>{item.label}</span>
                    {item.path === '/chat' && chatUnreadCount > 0 && (
                      <span style={{
                        background: '#ef4444',
                        color: 'white',
                        fontSize: '9px',
                        fontWeight: 900,
                        padding: '2px 7px',
                        borderRadius: '10px',
                        boxShadow: '0 2px 6px rgba(239, 68, 68, 0.5)'
                      }}>
                        {chatUnreadCount}
                      </span>
                    )}
                  </div>
                );
              })}
            </div>

            {/* Botón de Cerrar Sesión en Drawer */}
            <div style={{ paddingTop: '16px', borderTop: '1px solid rgba(255, 255, 255, 0.2)', marginTop: '16px' }}>
              <button
                onClick={logout}
                style={{
                  width: '100%',
                  padding: '12px',
                  borderRadius: '14px',
                  border: 'none',
                  background: 'rgba(239, 68, 68, 0.3)',
                  color: '#ffffff',
                  fontSize: '12.5px',
                  fontWeight: 800,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '8px',
                  cursor: 'pointer',
                  backdropFilter: 'blur(8px)'
                }}
              >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                  <polyline points="16 17 21 12 16 7" />
                  <line x1="21" y1="12" x2="9" y2="12" />
                </svg>
                Cerrar Sesión
              </button>
            </div>
          </div>
        </div>
      )}

      {/* 4. MODAL DE NOTIFICACIONES EN MÓVIL (BOTTOM SHEET) */}
      {showNotif && (
        <div
          onClick={() => setShowNotif(false)}
          style={{
            position: 'fixed',
            inset: 0,
            background: 'rgba(15, 42, 74, 0.55)',
            backdropFilter: 'blur(8px)',
            WebkitBackdropFilter: 'blur(8px)',
            zIndex: 1000,
            display: 'flex',
            alignItems: 'flex-end',
            animation: 'zoikFadeIn 0.2s ease-out'
          }}
        >
          <div
            onClick={e => e.stopPropagation()}
            style={{
              width: '100%',
              maxHeight: '80vh',
              background: '#ffffff',
              borderRadius: '24px 24px 0 0',
              boxShadow: '0 -8px 30px rgba(0,0,0,0.25)',
              display: 'flex',
              flexDirection: 'column',
              padding: '18px 20px calc(24px + var(--sab))',
              boxSizing: 'border-box',
              animation: 'zoikSlideUp 0.25s cubic-bezier(0.16, 1, 0.3, 1)'
            }}
          >
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '14px', borderBottom: '1px solid #f1f5f9', paddingBottom: '12px' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <span style={{ fontSize: '16px', fontWeight: 900, color: '#0f2a4a' }}>Notificaciones</span>
                {unreadCount > 0 && (
                  <span style={{ background: '#0070f3', color: 'white', fontSize: '10px', fontWeight: 800, padding: '2px 8px', borderRadius: '12px' }}>
                    {unreadCount} nuevas
                  </span>
                )}
              </div>
              <div style={{ display: 'flex', gap: '8px' }}>
                {unreadCount > 0 && (
                  <button
                    onClick={markAllRead}
                    style={{ background: 'none', border: 'none', color: '#0070f3', fontSize: '11px', fontWeight: 800, cursor: 'pointer' }}
                  >
                    Marcar todas
                  </button>
                )}
                <button
                  onClick={() => setShowNotif(false)}
                  style={{ background: '#f1f5f9', border: 'none', color: '#64748b', width: '28px', height: '28px', borderRadius: '50%', cursor: 'pointer', fontWeight: 900 }}
                >
                  ✕
                </button>
              </div>
            </div>

            <div style={{ overflowY: 'auto', flex: 1, display: 'flex', flexDirection: 'column', gap: '8px' }}>
              {notifications.length === 0 ? (
                <div style={{ padding: '30px', textAlign: 'center', color: '#64748b', fontSize: '13px' }}>
                  No tienes notificaciones pendientes
                </div>
              ) : (
                notifications.slice(0, 25).map(n => (
                  <div
                    key={n.id}
                    onClick={() => handleNotificationClick(n)}
                    style={{
                      padding: '12px 14px',
                      borderRadius: '14px',
                      background: n.read ? '#f8fafc' : 'rgba(0, 112, 243, 0.06)',
                      border: n.read ? '1px solid #e2e8f0' : '1px solid rgba(0, 112, 243, 0.2)',
                      cursor: 'pointer',
                      display: 'flex',
                      gap: '10px',
                      alignItems: 'flex-start'
                    }}
                  >
                    <span style={{ fontSize: '16px', marginTop: '2px' }}>{NOTIF_ICONS[n.type] || '🔔'}</span>
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{ fontSize: '12px', fontWeight: n.read ? 700 : 900, color: '#0f2a4a' }}>
                        {n.title || 'Notificación'}
                      </div>
                      {n.message && n.message !== n.title && (
                        <div style={{ fontSize: '11px', color: '#0070f3', marginTop: '2px' }}>
                          {n.message}
                        </div>
                      )}
                      <div style={{ fontSize: '9.5px', color: '#94a3b8', marginTop: '4px', fontWeight: 700 }}>
                        {timeAgo(n.createdAt)}
                      </div>
                    </div>
                  </div>
                ))
              )}
            </div>
          </div>
        </div>
      )}

    </div>

      {/* MODAL GLOBAL PARA EDITAR MI PERFIL Y DATOS PERSONALES */}
      <ProfileEditModal
        isOpen={showProfileEditModal}
        onClose={() => setShowProfileEditModal(false)}
        onProfileUpdated={(updated) => {
          if (updated?.avatar) {
            setProfileAvatar(updated.avatar);
          }
        }}
      />
    </>
  );
};

export default Sidebar;
